/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An RFC-3339 compliant Full Date Scalar */
  Date: { input: any; output: any; }
  /** An RFC-3339 compliant DateTime Scalar */
  DateTime: { input: any; output: any; }
  /** A 64-bit signed integer */
  Long: { input: any; output: any; }
};

export enum DuplicateStatus {
  ApiError = 'ApiError',
  DomainMatch = 'DomainMatch',
  DomainMismatch = 'DomainMismatch',
  ExistingUser = 'ExistingUser',
  None = 'None',
  SvAccountCreated = 'SvAccountCreated',
  SvAccountNotCreated = 'SvAccountNotCreated'
}

export enum DuplicateType {
  Aware = 'Aware',
  Unaware = 'Unaware'
}

export type GeneralSearchInput = {
  filterText?: InputMaybe<Scalars['String']['input']>;
  generalSearchText: Scalars['String']['input'];
  generalSearchType: SearchType;
};

export type GeneralSearchModel = {
  __typename?: 'GeneralSearchModel';
  id?: Maybe<Scalars['ID']['output']>;
  isAutocompleteEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type GeneralSearchResult = {
  __typename?: 'GeneralSearchResult';
  items: Array<GeneralSearchModel>;
  payload: Array<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LatLon = {
  __typename?: 'LatLon';
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
};

export type LatLonInput = {
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
};

export type Location = {
  __typename?: 'Location';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<Scalars['String']['output']>;
};

export type LocationCoordinates = {
  __typename?: 'LocationCoordinates';
  address: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  location: LatLon;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbr?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type LocationCoordinatesByKeyInput = {
  key: Scalars['String']['input'];
};

export type LocationSuggestion = {
  __typename?: 'LocationSuggestion';
  key?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Location */
export type LocationSuggestionInput = {
  countries?: InputMaybe<Scalars['String']['input']>;
  near?: InputMaybe<LatLonInput>;
  numSuggestions?: InputMaybe<Scalars['Int']['input']>;
  suggestionType?: InputMaybe<LocationSuggestionType>;
  text: Scalars['String']['input'];
};

export enum LocationSuggestionType {
  Any = 'Any',
  StreetAddressOnly = 'StreetAddressOnly'
}

export type Mutation = {
  __typename?: 'Mutation';
  createSiteApplication?: Maybe<SiteApplication>;
  createSiteVaultInvitations?: Maybe<Array<Maybe<SiteVaultInvitation>>>;
  trackUserEvent?: Maybe<Scalars['Boolean']['output']>;
  updateSite: UpdateSiteResponse;
};


export type MutationCreateSiteApplicationArgs = {
  application?: InputMaybe<SiteApplicationInput>;
};


export type MutationCreateSiteVaultInvitationsArgs = {
  input: SiteVaultInvitationInput;
};


export type MutationTrackUserEventArgs = {
  eventType: Scalars['String']['input'];
  eventValue: Scalars['String']['input'];
  trackingId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSiteArgs = {
  site: UpdateSiteInput;
  usn: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  generalSearch: GeneralSearchResult;
  getDuplicateStatus?: Maybe<DuplicateStatus>;
  getUsnVaultIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationCoordinatesByKey?: Maybe<LocationCoordinates>;
  locationSuggestions?: Maybe<Array<Maybe<LocationSuggestion>>>;
  searchSimilarSites?: Maybe<SiteSearchResult>;
  termsOfService: TermsOfService;
  validateSiteVaultInvitation?: Maybe<SiteVaultInvitationValidation>;
};


export type QueryGeneralSearchArgs = {
  input: GeneralSearchInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetDuplicateStatusArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLocationCoordinatesByKeyArgs = {
  query?: InputMaybe<LocationCoordinatesByKeyInput>;
};


export type QueryLocationSuggestionsArgs = {
  query?: InputMaybe<LocationSuggestionInput>;
};


export type QuerySearchSimilarSitesArgs = {
  query?: InputMaybe<SimilarSiteSearchInput>;
};


export type QueryValidateSiteVaultInvitationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SearchType {
  Country = 'COUNTRY',
  Employer = 'EMPLOYER',
  Location = 'LOCATION',
  Sponsor = 'SPONSOR'
}

export type SimilarSiteSearchInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Site = {
  __typename?: 'Site';
  abbreviation?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  departmentId?: Maybe<Scalars['String']['output']>;
  departmentSlug?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  organization?: Maybe<Scalars['String']['output']>;
  primaryContactFirstName?: Maybe<Scalars['String']['output']>;
  primaryContactJobTitle?: Maybe<Scalars['String']['output']>;
  primaryContactLastName?: Maybe<Scalars['String']['output']>;
  primaryContactPhoneNumber?: Maybe<Scalars['String']['output']>;
  primaryContactWorkEmail?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  usn: Scalars['ID']['output'];
  vaultId?: Maybe<Scalars['Int']['output']>;
};

export type SiteApplication = {
  __typename?: 'SiteApplication';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  duplicateUsn?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hasMultiLocations?: Maybe<Scalars['Boolean']['output']>;
  hasSmoContract?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isUniqueSite?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  marketingSource?: Maybe<Scalars['String']['output']>;
  orgCategory?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  siteName: Scalars['String']['output'];
  siteOrgName?: Maybe<Scalars['String']['output']>;
  siteSource?: Maybe<SiteSource>;
  siteType?: Maybe<SiteType>;
  smoAddress1?: Maybe<Scalars['String']['output']>;
  smoCity?: Maybe<Scalars['String']['output']>;
  smoCountry?: Maybe<Scalars['String']['output']>;
  smoState?: Maybe<Scalars['String']['output']>;
  smoZip?: Maybe<Scalars['String']['output']>;
  stateProvince?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studiesPerYear?: Maybe<Scalars['String']['output']>;
  teamGrouping?: Maybe<Scalars['String']['output']>;
  termsOfService?: Maybe<TermsOfService>;
  ticketId?: Maybe<Scalars['Long']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SiteApplicationEdit = {
  duplicateStatus?: InputMaybe<DuplicateStatus>;
};

export type SiteApplicationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  address3?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  duplicateType?: InputMaybe<DuplicateType>;
  duplicateUsn?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasMultiLocations?: InputMaybe<Scalars['Boolean']['input']>;
  hasSmoContract?: InputMaybe<Scalars['Boolean']['input']>;
  inviteId?: InputMaybe<Scalars['String']['input']>;
  isUniqueSite?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  marketingSource?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orgCategory?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  productsOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  referralSource?: InputMaybe<Scalars['String']['input']>;
  siteSource: SiteSource;
  siteType?: InputMaybe<SiteType>;
  smoAddress1?: InputMaybe<Scalars['String']['input']>;
  smoCity?: InputMaybe<Scalars['String']['input']>;
  smoCountry?: InputMaybe<Scalars['String']['input']>;
  smoState?: InputMaybe<Scalars['String']['input']>;
  smoZip?: InputMaybe<Scalars['String']['input']>;
  stateProvince?: InputMaybe<Scalars['String']['input']>;
  studiesPerYear?: InputMaybe<Scalars['String']['input']>;
  teamGrouping?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  usn?: InputMaybe<Scalars['String']['input']>;
  vaultId?: InputMaybe<Scalars['Long']['input']>;
};

export type SiteSearchResult = {
  __typename?: 'SiteSearchResult';
  sites: Array<Maybe<Site>>;
  total: Scalars['Int']['output'];
};

export enum SiteSource {
  CtGov = 'CT_GOV',
  DeptClaim = 'DEPT_CLAIM',
  McDirect = 'MC_DIRECT',
  SiteConnect = 'SITE_CONNECT',
  SsuApp = 'SSU_APP',
  SvApp = 'SV_APP'
}

export enum SiteType {
  Amc = 'AMC',
  Hospital = 'Hospital',
  Other = 'Other',
  PrivatePractice = 'PrivatePractice',
  Smo = 'SMO'
}

export type SiteVaultInvitation = {
  __typename?: 'SiteVaultInvitation';
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recordId?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  studyName?: Maybe<Scalars['String']['output']>;
  vaultId?: Maybe<Scalars['String']['output']>;
};

export type SiteVaultInvitationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  invitees: Array<SiteVaultInviteeInput>;
  sponsorName?: InputMaybe<Scalars['String']['input']>;
  studyName?: InputMaybe<Scalars['String']['input']>;
  vaultId?: InputMaybe<Scalars['Long']['input']>;
};

export type SiteVaultInvitationValidation = {
  __typename?: 'SiteVaultInvitationValidation';
  email?: Maybe<Scalars['String']['output']>;
  isClaimed: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  replyTo?: Maybe<Scalars['String']['output']>;
  sponsorName?: Maybe<Scalars['String']['output']>;
  studyName?: Maybe<Scalars['String']['output']>;
};

export type SiteVaultInviteeInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  recordId?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
};

export type TermsOfService = {
  __typename?: 'TermsOfService';
  /** The unique file revision id. */
  revision: Scalars['String']['output'];
  /** The url used to access the file. */
  url: Scalars['String']['output'];
};

export type UpdateSiteInput = {
  vaultId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSiteResponse = {
  __typename?: 'UpdateSiteResponse';
  usn: Scalars['String']['output'];
  vaultId?: Maybe<Scalars['Int']['output']>;
};

export type CreateSiteApplicationMutationVariables = Exact<{
  application?: InputMaybe<SiteApplicationInput>;
}>;


export type CreateSiteApplicationMutation = { __typename?: 'Mutation', createSiteApplication?: { __typename?: 'SiteApplication', id: string } | null };

export type TrackUserEventMutationVariables = Exact<{
  eventType: Scalars['String']['input'];
  eventValue: Scalars['String']['input'];
  trackingId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
}>;


export type TrackUserEventMutation = { __typename?: 'Mutation', trackUserEvent?: boolean | null };

export type TermsOfServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type TermsOfServiceQuery = { __typename?: 'Query', termsOfService: { __typename?: 'TermsOfService', url: string, revision: string } };

export type GeneralSearchQueryVariables = Exact<{
  input: GeneralSearchInput;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GeneralSearchQuery = { __typename?: 'Query', generalSearch: { __typename?: 'GeneralSearchResult', total?: number | null, payload: Array<string>, items: Array<{ __typename?: 'GeneralSearchModel', id?: string | null, name?: string | null, isAutocompleteEnabled?: boolean | null }> } };

export type ValidateSiteVaultInvitationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ValidateSiteVaultInvitationQuery = { __typename?: 'Query', validateSiteVaultInvitation?: { __typename?: 'SiteVaultInvitationValidation', isValid: boolean, isClaimed: boolean, studyName?: string | null, replyTo?: string | null, sponsorName?: string | null, email?: string | null } | null };

export type SearchSimilarSitesQueryVariables = Exact<{
  query?: InputMaybe<SimilarSiteSearchInput>;
}>;


export type SearchSimilarSitesQuery = { __typename?: 'Query', searchSimilarSites?: { __typename?: 'SiteSearchResult', total: number, sites: Array<{ __typename?: 'Site', usn: string, address1?: string | null, address2?: string | null, name: string, organization?: string | null, source?: string | null, location?: { __typename?: 'Location', city?: string | null, country?: string | null, stateProvince?: string | null, postalCode?: string | null } | null } | null> } | null };

export type LocationSuggestionsQueryVariables = Exact<{
  query: LocationSuggestionInput;
}>;


export type LocationSuggestionsQuery = { __typename?: 'Query', locationSuggestions?: Array<{ __typename?: 'LocationSuggestion', key?: string | null, text?: string | null } | null> | null };

export type LocationCoordinatesByKeyQueryVariables = Exact<{
  query?: InputMaybe<LocationCoordinatesByKeyInput>;
}>;


export type LocationCoordinatesByKeyQuery = { __typename?: 'Query', locationCoordinatesByKey?: { __typename?: 'LocationCoordinates', address: string, state?: string | null, stateAbbr?: string | null, streetAddress?: string | null, postalCode?: string | null, city?: string | null, countryCode?: string | null, countryName?: string | null } | null };

export type GetDuplicateStatusQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetDuplicateStatusQuery = { __typename?: 'Query', getDuplicateStatus?: DuplicateStatus | null };


export const CreateSiteApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSiteApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"application"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteApplicationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSiteApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"application"},"value":{"kind":"Variable","name":{"kind":"Name","value":"application"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSiteApplicationMutation, CreateSiteApplicationMutationVariables>;
export const TrackUserEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"trackUserEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackUserEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"eventType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventType"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventValue"}}},{"kind":"Argument","name":{"kind":"Name","value":"trackingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}]}]}}]} as unknown as DocumentNode<TrackUserEventMutation, TrackUserEventMutationVariables>;
export const TermsOfServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"termsOfService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"termsOfService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}}]}}]}}]} as unknown as DocumentNode<TermsOfServiceQuery, TermsOfServiceQueryVariables>;
export const GeneralSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"generalSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeneralSearchInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"size"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"500"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generalSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"size"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"payload"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isAutocompleteEnabled"}}]}}]}}]}}]} as unknown as DocumentNode<GeneralSearchQuery, GeneralSearchQueryVariables>;
export const ValidateSiteVaultInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"validateSiteVaultInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateSiteVaultInvitation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isValid"}},{"kind":"Field","name":{"kind":"Name","value":"isClaimed"}},{"kind":"Field","name":{"kind":"Name","value":"studyName"}},{"kind":"Field","name":{"kind":"Name","value":"replyTo"}},{"kind":"Field","name":{"kind":"Name","value":"sponsorName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<ValidateSiteVaultInvitationQuery, ValidateSiteVaultInvitationQueryVariables>;
export const SearchSimilarSitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSimilarSites"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SimilarSiteSearchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchSimilarSites"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usn"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"organization"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"stateProvince"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}}]}}]}}]} as unknown as DocumentNode<SearchSimilarSitesQuery, SearchSimilarSitesQueryVariables>;
export const LocationSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"locationSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationSuggestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationSuggestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<LocationSuggestionsQuery, LocationSuggestionsQueryVariables>;
export const LocationCoordinatesByKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"locationCoordinatesByKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationCoordinatesByKeyInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationCoordinatesByKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"stateAbbr"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"countryName"}}]}}]}}]} as unknown as DocumentNode<LocationCoordinatesByKeyQuery, LocationCoordinatesByKeyQueryVariables>;
export const GetDuplicateStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDuplicateStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDuplicateStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<GetDuplicateStatusQuery, GetDuplicateStatusQueryVariables>;